var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotakMahindraBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_21541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.146484 11.4764C0.146484 5.80091 5.49613 1.19922 12.096 1.19922C18.6959 1.19922 24.0451 5.80091 24.0451 11.4764C24.0451 17.152 18.6954 21.7537 12.096 21.7537C5.49659 21.7537 0.146484 17.1527 0.146484 11.4764Z",
    fill: "#003874"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6465 4.49932L13.4228 3.58203L13.4364 18.5897L10.6367 19.5277L10.6465 4.49932Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0839 12.5096C20.8234 14.6564 19.6192 16.8252 16.9897 16.8293C15.4546 16.8321 14.2554 15.781 13.425 14.495V13.0055C14.4642 13.5214 15.4355 14.0752 16.6139 14.0921C18.0656 14.1135 19.3783 13.5554 19.9212 12.5093H21.0841L21.0839 12.5096ZM12.2939 13.8576C11.0877 15.3116 9.92198 16.7968 7.73781 16.7968C4.65278 16.7968 3.18945 13.814 3.18945 11.3204C3.18945 8.92429 4.33304 6.08789 7.33854 6.08789C8.64211 6.08789 9.89691 6.88507 10.6449 7.72829L10.6426 9.76227C10.0177 9.34157 8.61795 8.92885 7.70409 8.91404C5.79819 8.88213 4.1179 9.70826 4.14708 11.5895C4.1669 12.8847 5.45019 13.765 6.72687 13.765C8.68222 13.765 9.86683 11.9788 10.8568 10.623C11.2537 10.1055 11.6461 9.58452 12.0339 9.06012C13.1335 7.52364 14.4058 6.12094 16.59 6.12094C19.163 6.12094 20.6074 8.1948 21.0158 10.3297H19.8535C19.3863 9.63738 18.4877 9.21372 17.6025 9.21372C15.5811 9.21372 14.3733 11.0734 13.3623 12.4426L12.2912 13.8573",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_21541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.5545,
    fill: "white",
    transform: "translate(0 1.19922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotakMahindraBank);
export default __webpack_public_path__ + "static/media/kotak-mahindra-bank.0c0dc1dc8db1cfda3ca046ede23a2fc0.svg";
export { ForwardRef as ReactComponent };